import styled from '@emotion/styled';
import React from 'react';

export const FormA = styled.form``;
